package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.ExploreW500RoundedFill: ImageVector
    get() {
        if (_exploreW500RoundedFill != null) {
            return _exploreW500RoundedFill!!
        }
        _exploreW500RoundedFill = Builder(name = "ExploreW500RoundedFill", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveToRelative(340.02f, 648.09f)
                lineToRelative(191.0f, -52.26f)
                quadToRelative(23.83f, -6.48f, 41.08f, -23.73f)
                reflectiveQuadToRelative(23.73f, -41.08f)
                lineToRelative(52.26f, -191.0f)
                quadToRelative(3.24f, -12.43f, -6.22f, -21.89f)
                reflectiveQuadToRelative(-21.89f, -6.22f)
                lineToRelative(-191.0f, 52.26f)
                quadToRelative(-23.83f, 6.48f, -41.08f, 23.73f)
                reflectiveQuadToRelative(-23.73f, 41.08f)
                lineToRelative(-52.26f, 191.0f)
                quadToRelative(-3.24f, 12.43f, 6.22f, 21.89f)
                reflectiveQuadToRelative(21.89f, 6.22f)
                close()
                moveTo(479.94f, 535.22f)
                quadToRelative(-23.03f, 0.0f, -39.09f, -16.12f)
                quadToRelative(-16.07f, -16.13f, -16.07f, -39.16f)
                quadToRelative(0.0f, -23.03f, 16.12f, -39.09f)
                quadToRelative(16.13f, -16.07f, 39.16f, -16.07f)
                quadToRelative(23.03f, 0.0f, 39.09f, 16.12f)
                quadToRelative(16.07f, 16.13f, 16.07f, 39.16f)
                quadToRelative(0.0f, 23.03f, -16.12f, 39.09f)
                quadToRelative(-16.13f, 16.07f, -39.16f, 16.07f)
                close()
                moveTo(480.0f, 888.13f)
                quadToRelative(-84.91f, 0.0f, -159.34f, -32.12f)
                quadToRelative(-74.44f, -32.12f, -129.5f, -87.17f)
                quadToRelative(-55.05f, -55.06f, -87.17f, -129.5f)
                quadTo(71.87f, 564.91f, 71.87f, 480.0f)
                reflectiveQuadToRelative(32.12f, -159.34f)
                quadToRelative(32.12f, -74.44f, 87.17f, -129.5f)
                quadToRelative(55.06f, -55.05f, 129.5f, -87.17f)
                quadToRelative(74.43f, -32.12f, 159.34f, -32.12f)
                reflectiveQuadToRelative(159.34f, 32.12f)
                quadToRelative(74.44f, 32.12f, 129.5f, 87.17f)
                quadToRelative(55.05f, 55.06f, 87.17f, 129.5f)
                quadToRelative(32.12f, 74.43f, 32.12f, 159.34f)
                reflectiveQuadToRelative(-32.12f, 159.34f)
                quadToRelative(-32.12f, 74.44f, -87.17f, 129.5f)
                quadToRelative(-55.06f, 55.05f, -129.5f, 87.17f)
                quadTo(564.91f, 888.13f, 480.0f, 888.13f)
                close()
            }
        }
        .build()
        return _exploreW500RoundedFill!!
    }

private var _exploreW500RoundedFill: ImageVector? = null
